function clearLocalStorage() {
  return new Promise<void>((resolve, reject) => {
    try {
      window.localStorage.clear();
      resolve();
    }
    catch (error) {
      reject(error);
    }
  });
}

export { clearLocalStorage };
